import type { Icon } from '../../../src/lib/types'
export const mdiFormatHorizontalAlignLeft: Icon = {
  "id": "format-horizontal-align-left",
  "name": "Format Horizontal Align Left",
  "path": "M11,16V13H21V11H11V8L7,12L11,16M3,20H5V4H3V20Z",
  "as": [],
  "tags": [
    "Text / Content / Format"
  ]
}
export default mdiFormatHorizontalAlignLeft